import GrowthNotification from '@/services/GrowthNotification';
import Analytics from '../analytics';
import { EVENT_LABELS } from '../analytics/labels';

export default class Mgm {
  static async getMgmConfigs(store: any, inTrial: boolean, openMgmModal: Function): Promise<any> {
    const { alreadyClosedMgmModal, alreadyClosedMgmHellobar, alreadySubscribedToMgm } =
      (await store.getters) || {
        alreadyClosedMgmModal: {},
        alreadyClosedMgmHellobar: false,
        alreadySubscribedToMgm: false,
      };
    if (!inTrial) {
      if (!alreadyClosedMgmModal?.timeClosed) {
        setTimeout(() => {
          this.trackingOpenMgm(alreadySubscribedToMgm);
          openMgmModal();
        }, 10000);
      } else {
        return this.displayMgmHellobar(
          alreadyClosedMgmModal.timeClosed,
          !!alreadyClosedMgmHellobar,
          !!alreadySubscribedToMgm,
          store,
        );
      }
    }
    return {};
  }

  static trackingOpenMgm(alreadySubscribedToMgm: boolean): void {
    Analytics.trackEvent(EVENT_LABELS.buttonClicked, {
      button: alreadySubscribedToMgm ? 'mgm-subscribed-modal-open' : 'mgm-modal-open',
    });
  }

  static trackHellobarDisplay(mgmHellobarType: number) {
    Analytics.trackEvent(EVENT_LABELS.mgmHellobarDisplayed, {
      type: `${mgmHellobarType}DaysHellobar`,
    });
  }

  static daysToMilliseconds(days: number): number {
    return days * 24 * 60 * 60 * 1000;
  }

  static async handleNotification(store: any) {
    GrowthNotification.notifyUser(store.getters.currentUser.email);
    await store.dispatch('CHANGE_GDH_DATA', {
      email: store.getters.currentUser.email,
      serviceData: { alreadyDisplayed30daysNotification: true },
    });
  }

  static displayMgmHellobar(
    closedModalDate: string,
    alreadyClosedMgmHellobar: boolean,
    alreadySubscribedToMgm: boolean,
    store: any,
  ): any {
    if (!alreadyClosedMgmHellobar && !alreadySubscribedToMgm) {
      const dateClosed = new Date(closedModalDate);
      const threeDaysInMilliseconds = this.daysToMilliseconds(3);
      const fifteenDaysInMilliseconds = this.daysToMilliseconds(15);
      const thirtyDaysInMilliseconds = this.daysToMilliseconds(30);
      const dateTimeDiff = new Date().getTime() - dateClosed.getTime();

      const mgmConfig = {
        showMgmHellobar: false,
        mgmHellobarType: 3,
      };
      if (dateTimeDiff >= threeDaysInMilliseconds) {
        mgmConfig.showMgmHellobar = true;
        if (dateTimeDiff >= fifteenDaysInMilliseconds && dateTimeDiff < thirtyDaysInMilliseconds) {
          this.trackHellobarDisplay(15);
          return {
            ...mgmConfig,
            mgmHellobarType: 15,
          };
        }
        if (dateTimeDiff >= thirtyDaysInMilliseconds) {
          if (!store.getters.alreadyDisplayed30daysNotification) {
            this.handleNotification(store);
          }
          return {
            ...mgmConfig,
            showMgmHellobar: false,
          };
        }
        this.trackHellobarDisplay(3);
      }
      return mgmConfig;
    }
    return {};
  }
}
